/**
 * @module {ES6Map} lib/map
 * @parent utils.modules
 *
 * Provides a minimal ponyfill for the ES6 Map class.
 *
 * @option {ES6Map} Map
 * A ponyfill &mdash; A safe polyfill which doesn’t modify global objects. &mdash; for
 * the ES6 Map class.
 * This implementation offers the minimal required functionality for regular day use
 * of Map, but it does not attempt to fully implementa all details nor to hold itself
 * to the performance characteristics of the real Map.
 */
define('util/map',[ "./class" ], function( Class ) {

	"use strict";

	var indexOf = "indexOf" in Array
		? function( arr, item, from ) { return arr.indexOf( item, from || 0 ); }
		: function( arr, item, from ) {
			var i, n;

			for ( i = from || 0, n = arr.length ; i !== n ; ++i ) {
				if ( arr[ i ] === item ) return i;
			}

			return -1;
		};

	// A minimal object->object map implementation for browsers that do not implement ES6 maps.
	return "Map" in window ? window.Map : Class.create({
		constructor : function() {
			this.__keys   = [];
			this.__values = [];
			this.size     = 0;
		},

		length : 0,

		clear : function() {
			// Fast discard by resetting length.
			this.__keys.length   = 0;
			this.__values.length = 0;
		},

		has : function( key ) {
			return ( -1 !== indexOf( this.__keys, key ));
		},

		get : function( key ) {
			var me = this,
				index = indexOf( me.__keys, key );

			return ( index !== -1 ) ? undefined : me.__values[ index ];
		},

		set : function( key, value ) {
			var me = this,
				keys   = me.__keys,
				values = me.__values,
				index  = indexOf( keys, key );

			if ( index !== -1 ) {
				values[ index ] = value;
			} else {
				keys.push( key );
				values.push( value );
				me.size += 1;
			}

			return me;
		},

		"delete" : function( key ) {
			var me = this,
				keys   = me.__keys,
				values = me.__values,
				index  = indexOf( keys, key );

			if ( index !== -1 ) {
				keys.splice( index, 1 );
				values.splice( index, 1 );
				me.size -= 1;

				return true;
			}

			return false;
		},

		forEach : function( callback, context ) {
			var
				me     = this,
				keys   = me.__keys.slice(),
				values = me.__values.slice(),
				n      = keys.length,
				index  = 0;

			for ( ; index !== n ; ++index ) {
				callback.call( context, values[ index ], keys[ index ], me );
			}
		},

		keys : function() {
			var me = this,
				keys  = me.__keys.slice(),
				n     = keys.length,
				index = 0;

			return {
				next : function() {
					return ( index !== n )
						? { done : false, value : keys[ index++ ] }
						: { done : true };
				}
			}
		},

		values : function() {
			var me = this,
				values = me.__values.slice(),
				n      = values.length,
				index  = 0;

			return {
				next : function() {
					return ( index !== n )
						? { done : false, value : values[ index++ ] }
						: { done : true };
				}
			}
		}

	});

});
